var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCheckboxGroupContext } from '@/hoc';
import { forwardRef } from 'react';
import { Checkbox } from './checkbox';
export var CheckboxGroupItem = forwardRef(function (_a, ref) {
    var value = _a.value, props = __rest(_a, ["value"]);
    var _b = useCheckboxGroupContext(), onChange = _b.onChange, groupValue = _b.value;
    var handleChange = function (e) {
        if (onChange) {
            var isChecked = e.target.checked;
            var newValue = groupValue || [];
            if (isChecked) {
                onChange(__spreadArray(__spreadArray([], newValue, true), [value], false));
            }
            else {
                onChange(newValue.filter(function (v) { return v !== value; }));
            }
        }
    };
    return (_jsx(Checkbox, __assign({ ref: ref, value: value, checked: groupValue === null || groupValue === void 0 ? void 0 : groupValue.includes(value), onChange: handleChange }, props)));
});
CheckboxGroupItem.displayName = 'CheckboxGroupItem';
